module.exports = __webpack_public_path__ + "img/logo.5e7aad83.jpg";